<template>
  <a-modal
    :title="title"
    :width="600"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="第三方">
          <a-input placeholder="请输入第三方" :maxLength="16" v-decorator="[ 'thirdParty', validatorRules.thirdParty]"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="名称">
          <a-input placeholder="请输入名称" :maxLength="16" v-decorator="[ 'thirdName', validatorRules.thirdName]"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="对接Key">
          <a-input placeholder="请输入对接Key" :maxLength="128" v-decorator="[ 'appKey']"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="对接密钥">
          <a-input placeholder="请输入对接密钥" :maxLength="128" v-decorator="[ 'appSecret']"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="AES Key">
          <a-input placeholder="请输入AES Key" :maxLength="128" v-decorator="[ 'aesKey']"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="平台公钥">
          <a-textarea placeholder="请输入平台公钥" :rows="4" :maxLength="2048" v-decorator="[ 'publicKey']"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="应用私钥">
          <a-textarea placeholder="请输入应用私钥" :rows="4" :maxLength="2048" v-decorator="[ 'privateKey']"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="状态">
          <a-select v-decorator="[ 'status', validatorRules.status]">
            <a-select-option :value="1">正常</a-select-option>
            <a-select-option :value="2">冻结</a-select-option>
          </a-select>
        </a-form-item>

      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import { addThird, editThird } from '@/webpublicapi/third'

export default {
  name: 'ThirdModal',
  data () {
    return {
      title: '操作',
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        thirdParty: { rules: [{ required: true, message: '请输入第三方!' }] },
        thirdName: { rules: [{ required: true, message: '请输入名称!' }] },
        status: { rules: [{ required: true, message: '请选择状态!' }], initialValue: 1 }
      }
    }
  },
  methods: {
    add () {
      this.edit({})
    },
    edit (record) {
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model, 'thirdParty', 'thirdName', 'appKey', 'appSecret', 'aesKey', 'publicKey', 'privateKey', 'status'))
      })
    },
    // 确定
    handleOk () {
      const that = this
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          values.thirdParty = (values.thirdParty || '').trim()
          values.thirdName = (values.thirdName || '').trim()
          values.appKey = (values.appKey || '').trim()
          values.appSecret = (values.appSecret || '').trim()
          values.aesKey = (values.aesKey || '').trim()
          const formData = Object.assign(this.model, values)
          let obj
          if (!this.model.id) {
            obj = addThird(formData)
          } else {
            obj = editThird(formData)
          }
          obj.then((res) => {
            if (res.code === 1000) {
              that.$message.success(res.msg)
              that.$emit('ok')
            } else {
              that.$message.warning(res.msg)
            }
          }).finally(() => {
            that.confirmLoading = false
            that.close()
          })
        }
      })
    },
    // 关闭
    handleCancel () {
      this.close()
    },
    close () {
      this.$emit('close')
      this.visible = false
    }
  }
}
</script>
